import { render, staticRenderFns } from "./EditWedding.vue?vue&type=template&id=06f842f1&scoped=true"
import script from "./EditWedding.vue?vue&type=script&lang=js"
export * from "./EditWedding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f842f1",
  null
  
)

export default component.exports